<template>
  <div class="container">
    <label for="">Preassessment ID</label>
    <input
      v-model="preassessment_id"
      type="text"
      style=" width:200px;margin-right:20px;margin-left:20px;"
    />
    <button class="button-green" @click="populateReports">Get Report</button>

    <table>
      <thead>
        <tr>
          <th>User</th>
          <th>Cohort</th>
          <th>Preassessment</th>
          <th>YouTube</th>
          <th>Points</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-if="items.length === 0"
          style="padding:50px;color:white;text-align:center;"
        >
          Loading
        </tr>
        <tr v-for="(item, i) in items" :key="i">
          <td>
            <div>{{ item.user.full_name }}</div>
            <div class="id-class-table">{{ item.user.id }}</div>
          </td>
          <td>
            <div>{{ item.cohort.name }}</div>
            <div class="id-class-table">{{ item.cohort.id }}</div>
          </td>
          <td>
            <div>{{ item.pre.name }}</div>
            <div class="id-class-table">{{ item.pre.id }}</div>
          </td>
          <td>
            <div>
              attempt : {{ item.youtube.pre_attempt }}
              <button @click="editDetails(item)">Update Attempt</button>
            </div>
          </td>
          <td>
            <div
              v-if="showUpdatePointsContainerIndex !== i"
              class=" link"
              @click="showUpdatePointsContainerIndex = i"
            >
              >
              <div>points: {{ item.youtube.user_points }}</div>
              <button>Update Points</button>
            </div>
            <div v-if="showUpdatePointsContainerIndex === i">
              <div><input v-model="points" type="text" /></div>
              <div>
                <button class="button-green" @click="updatePoints(item)">
                  Update Points
                </button>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <sweet-modal ref="updateDetailsModal" width="90%">
      <div class="row">
        <div class="small-6 columns">Name:</div>
        <div class="small-6 columns">
          {{ updateDetailsData.user.full_name }}
        </div>

        <div class="small-6 columns">Branch:</div>
        <div class="small-6 columns">
          <VueScout
            v-model="userSelectedBranches"
            :multiple="false"
            :taggable="false"
            :options="hardcodedBranches"
            label="name"
          />
        </div>
        <div class="small-6 columns">Year:</div>
        <div class="small-6 columns">
          <VueScout
            v-model="userSelectedYear"
            :multiple="false"
            :taggable="false"
            :options="hardcodedYears"
          />
        </div>
        <div class="small-6 columns">Youtube link:</div>
        <div class="small-6 columns">
          <div class="small-6 columns">
            {{ updateDetailsData.youtube.pre_attempt.youtubelink }}
          </div>
        </div>
        <div class="small-12 columns">
          <button @click="updateUserPreassessmentDetails">
            Update Details
          </button>
        </div>
      </div>
    </sweet-modal>
    <div class="pages-container">
      <div style="padding-bottom:5px;">pages:</div>
      <div
        v-for="page in totalPages"
        :key="page"
        class="page-number-selector link"
        :style="pageNumber === page ? 'background-color:#134e7b' : ''"
        @click="loadPage(page)"
      >
        {{ page }}
      </div>
    </div>
  </div>
</template>

<script>
import VueScout from "vue-scout"
import {
  SweetModal,
  // SweetModalTab
} from "sweet-modal-vue"
import siteConfig from "@/utils/siteConfig"

export default {
  components: {
    SweetModal,
    // SweetModalTab,
    VueScout,
  },
  data() {
    return {
      items: [],
      pageNumber: 1,
      preassessment_id: localStorage.report_preassessmentID,
      totalPages: 0,
      points: 0,
      /*  */
      showUpdatePointsContainerIndex: undefined,
      updateDetailsData: {
        user: {},
        pre: {},
        cohort: {},
        youtube: { pre_attempt: {} },
      },
      /*  */
      userSelectedBranches: [],
      userSelectedYear: [],
      hardcodedYears: [
        "2016",
        "2017",
        "2018",
        "2019",
        "2020",
        "2021",
        "2022",
        "2023",
        "2024",
      ],
      hardcodedBranches: [
        { code: "CIV", name: "CIV: CIVIL ENGINEERING" },
        { code: "EEE", name: "EEE: ELECTRICAL AND ELECTRONICS ENGINEERING " },
        { code: "INF", name: "INF: INFORMATION TECHNOLOGY" },
        { code: "MEC", name: "MEC: MECHANICAL ENGINEERING ENGNEERING " },
        { code: "CSE", name: "CSE: COMPUTER SCIENCE & ENGINEERING " },
        { code: "ECE", name: "ECE: ELECTRONICS AND COMMUNICATION ENGINEERING" },
        { code: "ANE", name: "ANE: AERONAUTICAL ENGINEERING " },
        { code: "BIO", name: "BIO: BIO-TECHNOLOGY (M.P.C. STREAM) " },
        { code: "CSS", name: "CSS: COMPUTER SCIENCE & SYSTEMS ENGINEERING " },
        {
          code: "DTD",
          name: "DTD: DIGITAL TECHNIQUES FOR DESIGN AND PLANNING ",
        },
        { code: "CEE", name: "CEE: CIVIL ENVIRONMENTAL ENGINEERING " },
        { code: "CHE", name: "CHE: CHEMICAL ENGINEERING" },
        { code: "CPE", name: "CPE: CHEMICAL PETRO ENGINEERING" },
        { code: "ECM", name: "ECM: ELECTRONICS AND COMPUTER ENGINEERING " },
        {
          code: "EIE",
          name: "EIE : ELECTRONICS AND INSTRUMENTATION ENGINEERING ",
        },
        { code: "GIN", name: "GIN: GEO-INFORMATICS " },
        { code: "MET", name: "MET: METALLURGICAL ENGINEERING " },
        { code: "MMT", name: "MMT: METALLURGY AND MATERIAL TECHNOLOGY " },
        { code: "ETM", name: "ETM: ELECTRNOICS & TELEMATICS " },
        { code: "FSP", name: "FSP: FACILITIES AND SERVICES PLANNING " },
        {
          code: "NMA",
          name: "NMA: NAVAL ARCHITECTURE AND MARINE ENGINEERING ",
        },
        { code: "PLG", name: "PLG: PLANNING ENGNEERING " },
        {
          code: "AEI",
          name: "AEI: APPLIED ELECTRONICS AND INSTRUMENTATION ENGG ",
        },
        { code: "AGR", name: "AGR : AGRICULTURAL ENGINEERING " },
        { code: "AUT", name: "AUT: AUTOMOBILE ENGINEERING " },
        { code: "BME", name: "BME: BIO-MEDICAL ENGINEERING " },
        { code: "CAB", name: "CAB: COMMERCIAL AGRICULTURAL & BUSINESS MGMT " },
        { code: "ECS", name: "ECS: ELECTRONICS CONTROL SYSTEMS ENGINEERING " },
        { code: "FDS", name: "FDS: FOOD SCIENCE " },
        { code: "CER", name: "CER : CHEMICAL (CERAMIC) TECHNOLOGY " },
        { code: "DRG", name: "DRG: DAIRYING " },
        { code: "FPT", name: "FPT : FOOD PROCESSING TECHNOLOGY " },
        { code: "ICE", name: "ICE: INSTRUMENTATION & CONTROL ENGINEERING " },
        {
          code: "IPE",
          name: "IPE: PRODUCTION / INDUSTRIAL PRODUCTION ENGINEERING ",
        },
        { code: "MIN", name: "MIN : MINING ENGINEERING " },
        { code: "TEX", name: "TEX : TEXTILE TECHNOLOGY PHARMACY COURSES " },
        {
          code: "IST",
          name: "IST : INSTRUMENTATION ENGINEERING / TECHNOLOGY ",
        },
        { code: "MCT", name: "MCT: MECHANICAL (MECHTRONICS) ENGINEERING" },
      ],
    }
  },
  mounted() {
    this.populateReports()
  },
  methods: {
    updateUserPreassessmentDetails() {
      const dataObj = {
        email: this.updateDetailsData.youtube.pre_attempt.email,
        name: this.updateDetailsData.youtube.pre_attempt.name,
        branch: this.userSelectedBranches[0].name,
        year: this.userSelectedYear[0],
        youtubelink: this.updateDetailsData.youtube.pre_attempt.youtubelink,
      }

      this.axios({
        method: "post",
        url:
          `${siteConfig.siteURL}questions/pre/attempt/` +
          `-LH9tqOKDDNPrC-84BTe` +
          `/${this.updateDetailsData.user.id}/${this.updateDetailsData.pre.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: { data: dataObj },
      }).then(() => {
        this.$refs.updateDetailsModal.close()
        this.items = []
        this.populateReports()
      })
    },
    editDetails(details) {
      this.$refs.updateDetailsModal.open()

      this.updateDetailsData = details
      for (let i = 0; i < this.hardcodedBranches.length; i++) {
        if (
          this.hardcodedBranches[i].name === details.youtube.pre_attempt.branch
        ) {
          this.userSelectedBranches = [this.hardcodedBranches[i]]
        }
      }

      this.userSelectedYear = [details.youtube.pre_attempt.year]
    },
    updatePoints(item) {
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}reports/video_resume/set/${item.user.id}/${item.pre.id}/${item.cohort.id}/${this.points}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        if (res.data === "success") {
          this.populateReports()
        }
      })
    },
    loadPage(page) {
      this.items = []
      this.pageNumber = page
      this.populateReports()
    },
    populateReports() {
      localStorage.report_preassessmentID = this.preassessment_id
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}reports/video_resume/${this.preassessment_id}?page=${this.pageNumber}&items_per_page=50`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.totalPages = res.data.pages + 1
        this.items = res.data.data
        this.showUpdatePointsContainerIndex = undefined
      })
    },
  },
}
</script>

<style>
.page-number-selector {
  display: inline-block;
  width: 24px;
  height: 24px;
  margin-top: 10px;
  margin-right: 10px;
  border: 1px solid white;
  border-radius: 100%;
  color: white;
  background-color: #44adff;
  font-size: 0.7em;
  line-height: 19px;
  text-align: center;
}
.pages-container {
  width: 450px;
  margin: auto;
  margin-top: 50px;
  color: black;
  user-select: none;
}
.id-class-table {
  color: white;
}
</style>
